import { useScoreStore } from 'store/ScoreStore'
import { useState } from 'react'
import Rooms from '../../data/rooms'

export default function HazardScore () {
  const [currentScore, setScore] = useState(0)

  useScoreStore.subscribe((newVal, oldVal) => {
    if (newVal.score !== oldVal.score) {
      setScore(newVal.score)
    }
  })

  const getHazardTitle = (id: string) => {
    const rooms = Rooms[useScoreStore.getState().roomScoreId]
    let returningId = id
    if (rooms && rooms.hazards) {
      const room = rooms.hazards.find((h) => {
        return h.id === id
      })
      if (room) returningId = room.title ?? id
    }

    return returningId
  }

  return (
    <div
      className={'absolute top-1 left-1 right-1 md:left-auto md:top-4 md:right-2 backdrop-blur select-none'}>
      <div className={'flex justify-between items-start md:block md:space-y-8 md:justify-center'}>
        <div className={'bg-white rounded-3xl bg-opacity-50 py-1 px-3 md:py-3 md:px-6'}>
          <div className={'flex justify-center items-center space-x-4'}>
            <h3 className={'text-primary-blue font-bold text-base md:text-lg font-museo-round'}>Your score</h3>
            <div className={'font-museo-round font-medium text-lg md:text-4xl'}>{currentScore}</div>
          </div>
        </div>

        {useScoreStore.getState().hazardsFound.length > 0 &&
          <div className={'hidden md:block bg-white rounded-3xl bg-opacity-50 py-3 px-6'}>
            <div className={'flex flex-col items-center space-y-4'}>
              <h3 className={'text-primary-blue font-bold text-lg font-museo-round text-center'}>Hazards found</h3>
              <div className={'font-museo-round'}>
                <ul>
                  {useScoreStore.getState().hazardsFound.map((h, index) => {
                    return (<li key={index}>{getHazardTitle(h)}</li>)
                  })}
                </ul>
              </div>
            </div>
          </div>
        }

        {useScoreStore.getState().showDoneButton &&
          <div className={'bg-white rounded-3xl bg-opacity-50 py-1 px-3 md:py-3 md:px-6'}>
            <div className={'flex flex-col items-center'}>
              <h3 className={'hidden md:block text-primary-blue font-bold text-lg font-museo-round text-center'}>
                I&apos;m done!
              </h3>
              <div className={'font-museo-round'}>
                <a href={'/score'}>
                  <button className={'btn_small--blue md:btn--blue'}>
                    Leave room
                  </button>
                </a>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}
